var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGuidedMode = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 154 103"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E3E8F0",
  d: "M79.007 100c27.344 0 49.51-22.386 49.51-50S106.351 0 79.007 0s-49.51 22.386-49.51 50 22.167 50 49.51 50"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M62.008 34.082a3.066 3.066 0 1 0 0-6.132 3.066 3.066 0 0 0 0 6.132"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0B0B0C",
  d: "M78.874 34.082a3.066 3.066 0 1 0 0-6.132 3.066 3.066 0 0 0 0 6.132"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M95.736 34.082a3.066 3.066 0 1 0 0-6.132 3.066 3.066 0 0 0 0 6.132"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#DFEAFB",
  d: "M87.305 67.807a3.832 3.832 0 1 0 0-7.665 3.832 3.832 0 0 0 0 7.665"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#guided-mode_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#guided-mode_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M127.309 47.269H25.761A3.76 3.76 0 0 0 22 51.03v18.805a3.76 3.76 0 0 0 3.761 3.761h101.548a3.76 3.76 0 0 0 3.761-3.76V51.03a3.76 3.76 0 0 0-3.761-3.761"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#B5C9D8",
  d: "M73.902 53.287H54.345a2.257 2.257 0 0 0 0 4.514h19.557a2.257 2.257 0 1 0 0-4.514"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#CCD2DC",
  d: "M87.442 63.066H54.345a2.257 2.257 0 1 0 0 4.513h33.097a2.257 2.257 0 1 0 0-4.513"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0B0B0C",
  d: "M42.307 49.526H28.015a3.76 3.76 0 0 0-3.76 3.761V67.58a3.76 3.76 0 0 0 3.76 3.761h14.292a3.76 3.76 0 0 0 3.761-3.76V53.286a3.76 3.76 0 0 0-3.76-3.76"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M37.898 62.89V64h-4.8v-1.11h1.758v-5.058q0-.3.018-.618l-1.248 1.044a.55.55 0 0 1-.216.108.522.522 0 0 1-.36-.06.4.4 0 0 1-.108-.102l-.468-.642 2.646-2.25h1.218v7.578z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "guided-mode_svg__a",
  width: 153.07,
  height: 70.327,
  x: 0,
  y: 32.269,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feDropShadow", {
  dx: 0,
  dy: 7,
  floodColor: "#60699D",
  floodOpacity: 0.1,
  stdDeviation: 11
})), /*#__PURE__*/React.createElement("filter", {
  id: "guided-mode_svg__b",
  width: 153.07,
  height: 70.327,
  x: 0,
  y: 32.269,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feDropShadow", {
  dx: 0,
  dy: 7,
  floodColor: "#60699D",
  floodOpacity: 0.1,
  stdDeviation: 11
})))));
export { SvgGuidedMode as ReactComponent };
export default "data:image/svg+xml;base64,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";